/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CommissionId} from "./commissionId.zod";

export const commissionDtoPercentageMin = 0;
export const commissionDtoPercentageMax = 100;
export const commissionDtoPercentageMultipleOf = 0.01;

export const CommissionDto = zod.object({
  commissionId: CommissionId,
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  name: zod.string().min(1),
  percentage: zod
    .number()
    .min(commissionDtoPercentageMin)
    .max(commissionDtoPercentageMax)
    .multipleOf(commissionDtoPercentageMultipleOf),
});

export type CommissionDto = zod.input<typeof CommissionDto>;
export type CommissionDtoOutput = zod.output<typeof CommissionDto>;
